 
 
 
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useEffect, useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import objectPath from "object-path";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { UserProfileDropdown } from "./dropdowns/UserProfileDropdown";
import * as actions from "../../../../store/actions/index";
import SVG from "react-inlinesvg";
import { getBaseImageURL } from "../../../../helpers";
export function QuickUserToggler() {
  const dispatch = useDispatch();
  const globalImagePath = useRef(getBaseImageURL());
  const uiService = useHtmlClassService();
  useEffect(() => {
    if (currentAdmin.role !== null) {
      dispatch(actions.getCurrentAdmin());
    }
    dispatch(actions.getGeneralSettings());
  }, []);
  const { currentAdmin } = useSelector((state) => state.adminAuth);
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.user.layout") === "offcanvas",
    };
  }, [uiService]);

  return (
    <>
      {layoutProps.offcanvas && (
        <OverlayTrigger
          placement="bottom"
          className="cursor-pointer"
          overlay={<Tooltip id="quick-user-tooltip">View user</Tooltip>}>
          <div className="topbar-item">
            <div
              className="d-flex bg-input-bg-clr gap-3 align-items-center px-3 py-2 rounded-fix cursor-pointer"
              style={{ cursor: "pointer" }}
              id="kt_quick_user_toggle">
              <>
                <span className="rounded-circle">
                  <img
                    src={
                      currentAdmin?.photo
                        ? `${globalImagePath.current}${currentAdmin.photo}`
                        : toAbsoluteUrl("media/users/default.jpg")
                    }
                    alt="ur"
                    height={26}
                    className="rounded-circle"
                    width={26}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = toAbsoluteUrl(
                        "media/users/default.jpg"
                      );
                    }}
                  />
                </span>
                <span className="d-none d-md-flex">
                  <SVG
                    src={toAbsoluteUrl(
                      "media/svg/icons/NewDashboard/menu-icon.svg"
                    )}></SVG>
                </span>
              </>
            </div>
          </div>
        </OverlayTrigger>
      )}

      {!layoutProps.offcanvas && <UserProfileDropdown />}
    </>
  );
}
